import { fromTemplate } from '../../utils/dom.js';
import './hero.css';

export class Hero {
  render() {
    const template = `
      <section class="sl-hero" id="top" data-testid="hero">
        <div class="container sl-hero__inner">
          <p class="sl-hero__eyebrow" data-testid="hero-eyebrow">Striking Labs</p>
          <h1 class="sl-hero__title" data-testid="hero-title">
            Thoughtful software,<br />
            <span class="sl-hero__accent">crafted with care.</span>
          </h1>
          <p class="sl-hero__lede" data-testid="hero-lede">
            We design and build modern websites and native apps for Apple
            platforms — iOS, iPadOS, and macOS — for teams that value
            simplicity, speed, and detail.
          </p>
          <div class="sl-hero__cta">
            <a class="sl-btn sl-btn--primary" href="#contact"
               data-testid="hero-cta-primary">Start a project</a>
            <a class="sl-btn sl-btn--ghost" href="#services"
               data-testid="hero-cta-secondary">See what we do</a>
          </div>
        </div>
      </section>
    `;
    return fromTemplate(template);
  }
}
